import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import Card10 from "../Images/Profiles/Patricia.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function PatriciaNyansheegu() {
  return (
    <div className="ne-page">
      <SEO
        title="Ms. Patricia Nyansheegu - Laboratory Quality Manager"
        description="Ms. Patricia Nyansheegu is the Laboratory Quality Manager at CIRCODU with a Bachelor's Degree in Conservation Forestry and Products Technology."
        keywords="Patricia Nyansheegu, Laboratory Quality Manager, CIRCODU, Bachelor's Degree, Conservation Forestry, Products Technology"
        url="/patricia-nyansheegu"
        image={Card10}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Ms. Patricia Nyansheegu</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/the-staff-team">
              The Staff Team
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Ms. Patricia Nyansheegu
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card10} alt="Ms. Patricia Nyansheegu" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Ms. Patricia Nyansheegu</h1>
                <p className="profile-card__role">Laboratory Quality Manager</p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Patricia Nyansheegu is an accomplished professional who holds
                  a Bachelor's Degree in Conservation Forestry and Products
                  Technology from Makerere University. Her dedication to
                  knowledge enhancement is underscored by a series of
                  prestigious professional certificates that showcase her
                  commitment to excellence and proficiency.
                </p>
                <p>
                  Her credentials encompass conducting internal audits based on
                  ISO:9001 and ISO/IEC 17025, a skill that underscores her
                  dedication to ensuring organizational quality standards. She
                  also holds a Certificate in Quality Management System based on
                  ISO/IEC 17025:2017, a credential that attests to her
                  competence in maintaining and optimizing quality protocols.
                  Furthermore, Patricia has earned a Certificate in Water
                  Boiling Tests (WBT), which encompasses diverse protocols for
                  evaluating cookstove emissions and efficiency in controlled
                  laboratory environments. Her capabilities extend to the
                  Controlled Cooking Test (C.C.T), as indicated by her
                  certification in Version 2.0 of this methodology. Patricia is
                  also proficient in Emissions Testing methods and protocols,
                  which further solidifies her expertise in the field.
                </p>
                <p>
                  Throughout her professional journey, Patricia's impact has
                  been substantial. Serving as a Laboratory Quality Manager at
                  CIRCODU since 2017, her role has been pivotal in ensuring the
                  highest standards of laboratory operations. Her prior roles
                  include serving as an Agroforestry Trainer with the
                  Presidential Initiation on Banana Industrial Development,
                  showcasing her commitment to sustainable agricultural
                  practices. Additionally, she excelled as a Quality Control
                  Manager at Fine Spinners Uganda Limited, a testament to her
                  ability to uphold product excellence. Patricia's experiences
                  extend to proficiency in quality control systems, Agroforestry
                  Management Systems, and adept use of data entry tools such as
                  SPSS, MS Office, PowerPoint, and Excel.
                </p>
                <p>
                  With over five years of professional experience, Patricia
                  Nyansheegu's career journey has been one of continuous
                  learning, practical application, and impactful contributions.
                  Her proficiency in quality management systems, paired with her
                  analytical skills, make her an asset to any endeavor she
                  undertakes.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://www.linkedin.com/in/patricia-nyansheegu-62473b286/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/Patricia0781161"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/patricia.nyansheegu"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256781165201"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:patricia.nyansheegu@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PatriciaNyansheegu;
